export enum MeetingHubEvents {
  SessionUpdated = 'SessionUpdated',
  AttendeeUpdated = 'AttendeeUpdated',
  AttendeeRemoved = 'AttendeeRemoved',
  VotingRoleRequested = 'VotingRoleRequested',
  CallReminderReceived = 'CallReminderReceived',
  MotionUpdated = 'MotionUpdated',
  VotesCleared = 'VotesCleared',
  VoteCasted = 'VoteCasted',
  DocumentUpdated = 'DocumentUpdated',
  RejectUpdated = 'RejectUpdated',
  TechnicalIssueUpdated = 'TechnicalIssueUpdated',
  CommentUpdated = 'CommentUpdated',
  ActivityLogAdded = 'ActivityLogAdded',
  ActivityLogRemoved = 'ActivityLogRemoved',
}

export default MeetingHubEvents;
